fragment DripSequencePreviewStubFragment on Campaign {
    id
    type
    name
    status
    htmlUrlPath
    lastStatusChangeTime
    createdTime
    startTrigger {
        id
        humanReadableTitle
        humanReadableSubtitle
    }
    editions {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            node {
                id
                name
                emailTemplate {
                    id
                    subject
                }
                backgroundColor
            }
        }
    }
    from {
        id
        emailAddress {
            formatted
        }
    }
}
